import { __decorate } from "tslib";
import React, { Component } from 'react';
import { withRouter, connect } from '@souche-f2e/muji';
import { Tabs, Button, Modal } from 'antd';
import { dispatch } from '@@/store';
import { WhiteSpace, showInfo } from '@/components';
import AuthorizedTab from '@/components/Auth/authTab';
import AuthorizedOr from '@/components/Auth/authOr';
import { showCarDetail, showRejectReason, fontEndConfig } from '@/shared/utils';
import { dealValueShow } from '@/shared/functions';
import { FromSearch, ApproveResultAll, ApproveResultSuccess, ApproveResultFail, } from './_components';
import styles from './_style/index.less';
import { jumpReport } from '@/shared/functions';
const mapStateToProps = (rootState) => ({
    approve: rootState.approve,
    carDetail: rootState.carDetail,
    resources: rootState.global.resources,
});
// @ts-ignore
let ApproveManage = class ApproveManage extends Component {
    constructor(props) {
        super(props);
        this.routeIsMy = false;
        // desc 跳转展示待审批详情页
        this.linkToDetail = (event, data, rowIndex) => {
            const { activeTab } = this.props.approve;
            // activeTab === 'All' ? this.setState({
            //   showDetail:
            //   })
            showCarDetail(data.goodsId, () => {
                return activeTab === 'All' ? (<AuthorizedOr allow={['psgjb-carpend-examine', 'psgjb-carpendmine-examine']}>
          <div className={styles.form_control}>
            <Button onClick={this.unAgree}>驳回</Button>
            <Button type={'primary'} onClick={this.agree}>通过</Button>
          </div>
        </AuthorizedOr>) : null;
            });
        };
        // desc 审批通过
        this.agree = () => {
            const carDetails = this.props.carDetail;
            Modal.confirm({
                title: '是否确定通过',
                onOk() {
                    dispatch.approve.agreeApprove({
                        idList: [carDetails.goodsId],
                        callback: () => {
                            dispatch.carDetail.show(false);
                        },
                    });
                },
            });
        };
        // desc 审批驳回
        this.unAgree = () => {
            const id = this.props.carDetail.goodsId;
            showRejectReason({
                id,
                callback: () => {
                    dispatch.carDetail.show(false);
                },
            });
        };
        // desc 展示经销商详情
        this.showSeller = (event, data, rowIndex) => {
            showInfo('seller', data.sellerCode);
        };
        this.changeTab = this.changeTab.bind(this);
        this.unAgree = this.unAgree.bind(this);
        this.agree = this.agree.bind(this);
        this.state = {
            colums: [
                {
                    title: '车型',
                    align: 'left',
                    dataIndex: 'carModelName',
                    width: 350,
                    onCell: (record, rowIndex) => ({
                        onClick: (event) => {
                            this.linkToDetail(event, record, rowIndex);
                        },
                    }),
                    render: (text, record, index) => {
                        let lubanID = '';
                        const { isMy, activeTab } = this.props.approve;
                        const isRealMy = isMy || this.routeIsMy;
                        switch (activeTab) {
                            case 'All':
                                lubanID = isRealMy ? 'PSGJB-CAR-QBSP-WDDSP-CLXQ' : 'PSGJB-CAR-QBSP-QBDSP-CLXQ';
                                break;
                            default:
                                lubanID = undefined;
                                break;
                        }
                        const showIcon = record.reportType === 1;
                        const v268 = require('@/assets/report/268v_2.png');
                        return (<a luban-id={lubanID} className={styles.table_item_operate}>
                {showIcon && <img src={v268} style={{
                            width: 36,
                            height: 18,
                            marginRight: 6,
                        }}/>}
                {text}
              </a>);
                    },
                },
                {
                    title: '车辆所在地',
                    dataIndex: 'locationName',
                    align: 'left',
                },
                {
                    title: '卖家经销商',
                    dataIndex: 'sellerName',
                    align: 'left',
                    onCell: (record, rowIndex) => ({
                        onClick: (event) => {
                            record.sellerName && this.showSeller(event, record, rowIndex);
                        },
                    }),
                    render: (text, record, index) => {
                        let lubanID = '';
                        const { isMy, activeTab } = this.props.approve;
                        const isRealMy = isMy || this.routeIsMy;
                        switch (activeTab) {
                            case 'All':
                                lubanID = isRealMy ? 'PSGJB-CAR-QBSP-WDDSP-MFJXS' : 'PSGJB-CAR-QBSP-QBDSP-MFJXS';
                                break;
                            case 'Success':
                                lubanID = isRealMy ? 'PSGJB-CAR-QBSP-WDSPCG-MFJXS' : 'PSGJB-CAR-QBSP-QBSPCG-MFJXS';
                                break;
                            default:
                                lubanID = undefined;
                                break;
                        }
                        return (<a luban-id={lubanID} className={styles.table_item_operate}>
                {text}
              </a>);
                    },
                },
                {
                    title: '车牌号',
                    dataIndex: 'license',
                    align: 'left',
                },
                {
                    title: 'VIN码',
                    dataIndex: 'vin',
                    align: 'left',
                },
                {
                    title: '车况等级',
                    dataIndex: 'rankDesc',
                    align: 'left',
                    render: (text, record) => {
                        const level = record.rankLevel === fontEndConfig.noValueReplace ? '' : record.rankLevel;
                        const levelA = text === fontEndConfig.noValueReplace ? '' : text;
                        return dealValueShow((level + levelA) === 'undefined' ? '' : (level + levelA), false, fontEndConfig.noValueReplace);
                    },
                },
                {
                    title: '保留价(元)',
                    dataIndex: 'basePriceYuan',
                    align: 'left',
                },
                // {
                //   title: '收购价(元)',
                //   dataIndex: 'buyPriceYuan',
                //   align: 'left',
                // },
                {
                    title: '起拍价(元)',
                    dataIndex: 'auctionPriceYuan',
                    align: 'left',
                },
                {
                    title: '检测报告',
                    dataIndex: 'reportUrl',
                    align: 'left',
                    onCell: (record, rowIndex) => ({
                        onClick: (event) => {
                            if (record.reportUrl && record.reportUrl !== '') {
                                jumpReport(record.reportUrl);
                            }
                        },
                    }),
                    render: (text, record, index) => {
                        let lubanID = '';
                        const { isMy, activeTab } = this.props.approve;
                        const isRealMy = isMy || this.routeIsMy;
                        switch (activeTab) {
                            case 'All':
                                lubanID = isRealMy ? 'PSGJB-CAR-QBSP-WDDSP-JCBG' : 'PSGJB-CAR-QBSP-QBDSP-JCBG';
                                break;
                            case 'Success':
                                lubanID = isRealMy ? 'PSGJB-CAR-QBSP-WDSPCG-JCBG' : 'PSGJB-CAR-QBSP-QBSPCG-JCBG';
                                break;
                            default:
                                lubanID = undefined;
                                break;
                        }
                        return (text && text !== '') ?
                            (<a luban-id={lubanID}>
                  查看
                </a>) : (<span>暂无</span>);
                    },
                },
            ],
        };
    }
    // desc 切换tab（切换全部待审批，全部审批成功，全部审批失败）
    changeTab(key) {
        dispatch.approve.SET_STATE({
            activeTab: key.split('-')[1],
        });
        dispatch.approve.updateTable({});
    }
    componentWillUnmount() {
        dispatch.approve.resetState({});
    }
    render() {
        const { currentRoute } = this.props;
        const routeIsMy = currentRoute.path.toLowerCase().includes('my');
        this.routeIsMy = routeIsMy;
        const { isMy } = this.props.approve;
        const { colums } = this.state;
        const isRealMy = isMy || routeIsMy;
        return (<React.Fragment>
        <FromSearch />
        <WhiteSpace />
        <AuthorizedTab type={'card'} onTabClick={this.changeTab} allow={[
            isRealMy ? 'psgjb-carpendmine-view' : 'psgjb-carpend-view',
            isRealMy ? 'psgjb-carthromine-view' : 'psgjb-carthrough-view',
            isRealMy ? 'psgjb-carrejectmine-view' : 'psgjb-carreject-view',
        ]}>
          <Tabs.TabPane key={isRealMy ? 'm-All' : 'a-All'} tab={`${isRealMy ? '我的' : '全部'}待审批`}>
            <ApproveResultAll tableColums={colums}/>
          </Tabs.TabPane>
          <Tabs.TabPane key={isRealMy ? 'm-Success' : 'a-Success'} tab={`${isRealMy ? '我的' : '全部'}审批成功`}>
            <ApproveResultSuccess tableColums={colums}/>
          </Tabs.TabPane>
          <Tabs.TabPane key={isRealMy ? 'm-Fail' : 'a-Fail'} tab={`${isRealMy ? '我的' : '全部'}审批驳回`}>
            <ApproveResultFail tableColums={colums}/>
          </Tabs.TabPane>
        </AuthorizedTab>
      </React.Fragment>);
    }
};
ApproveManage = __decorate([
    withRouter
], ApproveManage);
export default connect(mapStateToProps)(ApproveManage);
